import catAll from './assets/cat-all.png';
import catCpg from './assets/cat-cpg.png';
import catRestaurant from './assets/cat-restaurant.png';
import catHotel from './assets/cat-hotel.png';
import catOther from './assets/cat-other.png';
import highPaying from './assets/high-paying.png';

/** Board / propose chip icons, keyed by BountyCategory plus the board-only 'all' and 'highPaying' filters. */
export const CATEGORY_ICONS: Record<string, string> = {
  all: catAll,
  cpgBrand: catCpg,
  restaurant: catRestaurant,
  hotelsLodging: catHotel,
  other: catOther,
  highPaying,
};
